import React from 'react';
import { Row, Typography } from 'antd';
import styled from 'styled-components';

const Text = styled(Typography.Text)`
  line-height: 2.0;
  font-size: 16px;
`;

interface BioProps {
  expert: {
    bio?: string | null;
  };
}

const Bio = function ({ expert }: BioProps) {
  const { bio } = expert;

  return bio && (
    <Row>
      <Text>{bio}</Text>
    </Row>
  );
};

export default Bio;
